export default {
    name: 'API',
    baseURI: 'https://alza.web.id/tosmapi/',
  }

  